// matter-article.js: shared behaviour for every page on the `page.matter` template
// (loaded unconditionally by templates/page.matter.liquid, line ~157).
//
// 2026-10-19: null-guarded. Pages on page.matter that don't carry the article nav
// (#nav / #navToggle / #navLinks), most visibly /pages/quiz-v3, were throwing
// "Cannot read properties of null (reading 'classList')" on EVERY scroll event, plus a
// one-off "null.addEventListener" on load that aborted the rest of this file. That was
// ~97% of the JS errors Clarity logged on the quiz (60% of sessions vs 7% on the PDP).
// Behaviour on pages that DO have the nav is unchanged.
// Previous live version: templates/shopify-theme/_live-backup-2026-04-29/matter-article.js

// Nav frost on scroll
var nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', function() {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// Mobile nav toggle
var navToggle = document.getElementById('navToggle');
var navLinks = document.getElementById('navLinks');
if (navToggle) {
  navToggle.addEventListener('click', function() {
    navToggle.classList.toggle('open');
    if (navLinks) navLinks.classList.toggle('open');
  });
}

// Scroll reveal (IntersectionObserver at 12% threshold)
var reveals = document.querySelectorAll('.reveal');
if (reveals.length && 'IntersectionObserver' in window) {
  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(function(el) { revealObserver.observe(el); });
} else {
  reveals.forEach(function(el) { el.classList.add('visible'); });
}

// Scroll-spy TOC
var tocLinks = document.querySelectorAll('.toc ol li a');
var sections = [];
tocLinks.forEach(function(link) {
  var id = link.getAttribute('data-section');
  var section = id && document.getElementById(id);
  if (section) sections.push({ el: section, link: link });
});

if (sections.length) {
  var updateToc = function() {
    var scrollPos = window.scrollY + 140;
    var activeIndex = 0;
    sections.forEach(function(s, i) {
      if (s.el.offsetTop <= scrollPos) activeIndex = i;
    });
    tocLinks.forEach(function(l) { l.classList.remove('active'); });
    if (sections[activeIndex]) sections[activeIndex].link.classList.add('active');
  };
  window.addEventListener('scroll', updateToc, { passive: true });
  updateToc();
}
